import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { heroGuarantees } from '../data/content';
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-12 pt-4 sm:pb-20 sm:pt-10" style={{
    paddingTop: '15px'
  }} data-id="element-115" data-mp="ei1unjxvvyww">
      <div className="mx-auto max-w-4xl text-center" data-id="element-116" data-mp="4m8nyh6uizn1">
        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="text-[11px] font-bold uppercase leading-tight tracking-[0.18em] text-teal sm:text-xs sm:tracking-[0.22em]" data-id="element-117" data-mp="4njpsbgqdxbi">
          Il sistema di Fisica completo per i docenti delle scuole superiori
          italiane
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: 'easeOut'
      }} className="mt-3 font-display text-[2.25rem] font-black leading-[1.06] tracking-tight text-navy sm:mt-5 sm:text-[3.4rem] md:text-[4rem]" data-id="element-118" data-mp="neknkw647mth">
          Prepara un Intero Anno di Fisica in Soli{' '}
          <span className="italic text-grape" data-id="element-119" data-mp="3o6u697yqynbv">5 Minuti</span> di Orologio.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.12,
        ease: 'easeOut'
      }} className="mx-auto mt-3 max-w-2xl text-[15px] leading-snug text-navy/60 sm:mt-6 sm:text-lg sm:leading-relaxed" data-id="element-120" data-mp="39a36uyp2pbm9">
          <span className="sm:hidden" data-id="element-121" data-mp="35a2hij0frg0f">
            5 volumi PDF pronti all&apos;uso per tutto il percorso del Liceo.
            Stampa, apri e insegna.
          </span>
          <span className="hidden sm:inline" data-id="element-122" data-mp="2vjzmyedo1tzz">
            FISICA PRONTA è il sistema completo «chiavi in mano»: 5 volumi PDF
            pronti all&apos;uso carichi di teoria visuale, esercizi svolti e
            verifiche per tutto il percorso del Liceo. Basta stampare, aprire e
            insegnare.
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="mx-auto mt-3 max-w-2xl sm:mt-10" data-id="element-123" data-mp="s3uq3ug3l49k">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/f5e3bbd8-f324-476a-8a9a-b2a64537ee47.jpg" alt="Il pacchetto FISICA PRONTA: 5 volumi stampati, la versione digitale su computer, tablet e smartphone e i 5 bonus" className="mx-auto max-h-[34vh] w-full object-contain sm:max-h-none" data-id="element-124" data-mp="ddwz76qsa0go" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3,
        ease: 'easeOut'
      }} className="mt-3 sm:mt-8" data-id="element-125" data-mp="x1edpkyoqte6">
          <CtaButton href="#offerta" data-id="element-126" data-mp="3hr3rdunnk95a" />
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[11px] font-semibold text-navy/55 sm:mt-5 sm:gap-x-3 sm:gap-y-2 sm:text-xs" data-id="element-127" data-mp="3hq266xcxa69u">
            {heroGuarantees.map((item, index) => <li key={item} className="flex items-center gap-2 sm:gap-3" data-id="element-128" data-mp="269zivui4kzox" data-mpi={index}>
                <span data-id="element-129" data-mp="268obzltdvbtl">
                  <span aria-hidden="true" className="text-teal" data-id="element-130" data-mp="2b0plx132wqgg">
                    ✓{' '}
                  </span>
                  {item}
                </span>
                {index < heroGuarantees.length - 1 && <span aria-hidden="true" className="text-navy/25" data-id="element-131" data-mp="2kydscoa1rmeg">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}